import _ from 'lodash';
import { FC } from 'react';
import { useTable, useSortBy, Column } from 'react-table';
import TableEmpty from './components/empty/TableEmpty';

import Table from './Table';

const { Container, Head, Row, HeaderCell, Body, Cell } = Table;

export interface DataTableProps {
  title?: string;
  sortable?: boolean;
  data: readonly Record<string, unknown>[];
  columns: readonly Column<Record<string, unknown>>[];
  className?: string;
}

const DataTable: FC<DataTableProps> = ({ title, sortable = false, data, columns, className = '' }) => {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({ columns, data }, useSortBy);

  return (
    <Container title={title} className={className}>
      <Table {...getTableProps()}>
        <Head>
          {headerGroups.map((headerGroup, index) => (
            <Row {...headerGroup.getHeaderGroupProps()} key={index}>
              {headerGroup.headers.map((column) => (
                <HeaderCell
                  sortable={sortable}
                  column={column}
                  align="center"
                  {...column.getHeaderProps(sortable ? (column as any).getSortByToggleProps() : undefined)}
                  key={column.id}
                >
                  {column.render('Header')}
                </HeaderCell>
              ))}
            </Row>
          ))}
        </Head>
        <Body {...getTableBodyProps()}>
          {_.isEmpty(rows) ? (
            <TableEmpty />
          ) : (
            rows.map((row) => {
              prepareRow(row);
              return (
                <Row {...row.getRowProps()} key={row.id}>
                  {row.cells.map((cell) => {
                    const key = `${cell.column.id}-${cell.row.id}`;
                    return (
                      <Cell align="center" {...cell.getCellProps()} key={key}>
                        {cell.render('Cell')}
                      </Cell>
                    );
                  })}
                </Row>
              );
            })
          )}
        </Body>
      </Table>
    </Container>
  );
};

export default DataTable;
